import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Filter = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M9.99988 7C7.79074 7 5.99988 8.79086 5.99988 11C5.99988 13.2091 7.79074 15 9.99988 15C12.209 15 13.9999 13.2091 13.9999 11C13.9999 8.79086 12.209 7 9.99988 7ZM3.99988 11C3.99988 7.68629 6.68617 5 9.99988 5C12.9729 5 15.4408 7.16229 15.9169 10L35 9.99999C35.5523 9.99999 36 10.4477 36 11C36 11.5523 35.5523 12 35 12L15.9169 12C15.4408 14.8377 12.9729 17 9.99988 17C6.68617 17 3.99988 14.3137 3.99988 11ZM30 25C27.7909 25 26 26.7908 26 29C26 31.2091 27.7908 33 30 33C32.2091 33 34 31.2091 34 29C34 26.7908 32.2091 25 30 25ZM24.0829 28C24.559 25.1623 27.027 23 30 23C33.3137 23 36 25.6863 36 29C36 32.3137 33.3137 35 30 35C27.027 35 24.559 32.8377 24.0829 30L4.99999 30C4.4477 30 3.99999 29.5523 3.99999 29C3.99999 28.4477 4.4477 28 4.99999 28L24.0829 28Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Filter;
